import { StoreRepository } from './repositories/store'
import { StoreService } from './services/store'

const storeRepository = new StoreRepository()

export const storeService = new StoreService({ storeRepository })
